<template>
    <section>
        <div
            class="bg-blue-600 hover:bg-blue-500 transition-all duration-1000 hidden"
            v-if="texts.topbar"
        >
            <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
                <div class="flex items-center justify-between flex-wrap">
                    <a
                        class="w-0 flex-1 flex items-center group cursor-pointer"
                        :href="
                            lang == 'nl'
                                ? 'https://online-alv.nl/uitleg?locale=' + lang
                                : 'https://online-mgv.de/hilfe/'
                        "
                        target="_blank"
                    >
                        <span
                            class="flex p-2 rounded-lg bg-blue-400 group-hover:animate-bounce group-hover:bg-blue-600 transition-all duration-300"
                        >
                            <SupportIcon
                                class="h-6 w-6 text-white"
                                aria-hidden="true"
                            />
                        </span>
                        <p
                            class="ml-3 font-medium text-white group-hover:font-blue-50"
                        >
                            <span>
                                {{ texts.topbar }}
                            </span>
                        </p>
                    </a>
                </div>
            </div>
        </div>
        <div class="py-6 sm:py-8">
            <div class="relative sm:py-16">
                <div
                    class="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8"
                >
                    <logo-nl
                        height="h-32 h-32
                            my-4
                            mx-auto
                            transform
                            hover:scale-110
                            transition
                            duration-500
                            ease-in-out"
                        class="h-32 my-4 mx-auto transform hover:scale-110 transition duration-500 ease-in-out"
                    ></logo-nl>
                    <div
                        class="relative rounded-2xl px-6 py-10 overflow-hidden shadow-xl sm:px-12 sm:py-20 transition-colors duration-500"
                        :class="{
                            'bg-yellow-600': form.state == 'yellow',
                            'bg-green-600': form.state == 'green',
                            'bg-blue-600': form.state == 'blue',
                            'bg-red-600': form.state == 'red',
                            'bg-indigo-600': form.state == 'indigo',
                        }"
                    >
                        <div
                            aria-hidden="true"
                            class="absolute inset-0 -mt-72 sm:-mt-32 md:mt-0"
                        >
                            <svg
                                class="absolute inset-0 h-full w-full"
                                preserveAspectRatio="xMidYMid slice"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 1463 360"
                            >
                                <path
                                    class="text-opacity-40 transition-colors duration-500"
                                    :class="{
                                        'text-yellow-500':
                                            form.state == 'yellow',
                                        'text-green-500': form.state == 'green',
                                        'text-blue-500': form.state == 'blue',
                                        'text-red-500': form.state == 'red',
                                        'text-indigo-500':
                                            form.state == 'indigo',
                                    }"
                                    fill="currentColor"
                                    d="M-82.673 72l1761.849 472.086-134.327 501.315-1761.85-472.086z"
                                />
                                <path
                                    class="text-opacity-40 transition-colors duration-500"
                                    :class="{
                                        'text-yellow-700':
                                            form.state == 'yellow',
                                        'text-green-700': form.state == 'green',
                                        'text-blue-700': form.state == 'blue',
                                        'text-red-700': form.state == 'red',
                                        'text-indigo-700':
                                            form.state == 'indigo',
                                    }"
                                    fill="currentColor"
                                    d="M-217.088 544.086L1544.761 72l134.327 501.316-1761.849 472.086z"
                                />
                            </svg>
                        </div>
                        <div class="relative">
                            <div class="sm:text-center">
                                <h2
                                    class="text-3xl font-extrabold text-white tracking-tight sm:text-4xl"
                                >
                                    {{ texts.title }}
                                </h2>
                                <p
                                    v-if="texts.content"
                                    class="mt-6 mx-auto max-w-2xl text-lg"
                                    :class="{
                                        'text-yellow-50':
                                            form.state == 'yellow',
                                        'text-green-50': form.state == 'green',
                                        'text-blue-50': form.state == 'blue',
                                        'text-red-50': form.state == 'red',
                                        'text-indigo-50':
                                            form.state == 'indigo',
                                    }"
                                >
                                    <abbr
                                        v-if="
                                            user.phone != 'error' && user.name
                                        "
                                        :title="user.email"
                                        >{{ user.name }},</abbr
                                    >
                                    {{ texts.content }}
                                    <kbd
                                        class="text-base"
                                        v-if="
                                            user.phone && user.phone != 'error'
                                        "
                                        ><b>{{ user.phone }}</b></kbd
                                    >
                                </p>
                            </div>

                            <form
                                v-on:submit.prevent="requestSMS"
                                novalidate
                                v-if="form.type == 'request-sms'"
                                class="mt-6 sm:mx-auto sm:max-w-xl sm:flex"
                            >
                                <div class="mt-4 sm:mt-0 sm:ml-3 mx-auto">
                                    <button
                                        v-if="!loading && showButton"
                                        type="submit"
                                        @click="
                                            $event.currentTarget.classList.add(
                                                'clicked',
                                            )
                                        "
                                        class="block w-full rounded-md border border-transparent px-5 py-3 text-base font-medium text-white shadow focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 sm:px-10 kunjelatenbouncen"
                                        :class="{
                                            'bg-yellow-500 hover:bg-yellow-400 focus:ring-offset-yellow-600':
                                                form.state == 'yellow',
                                            'bg-green-500 hover:bg-green-400 focus:ring-offset-green-600':
                                                form.state == 'green',
                                            'bg-blue-500 hover:bg-blue-400 focus:ring-offset-blue-600':
                                                form.state == 'blue',
                                            'bg-red-500 hover:bg-red-400 focus:ring-offset-red-600':
                                                form.state == 'red',
                                            'bg-indigo-500 hover:bg-indigo-400 focus:ring-offset-indigo-600':
                                                form.state == 'indigo',
                                        }"
                                    >
                                        <span>{{ texts.button }}</span>
                                    </button>
                                    <icon-loader
                                        v-if="loading"
                                        class="text-white mt-3 inline-block transition-all duration-500 ease-in-out mx-auto"
                                    ></icon-loader>
                                </div>
                            </form>
                            <form
                                v-on:submit.prevent="validateCode"
                                novalidate
                                v-if="form.type == 'validate-code'"
                                class="mt-6 sm:mx-auto sm:max-w-xl sm:flex"
                            >
                                <div class="min-w-0 flex-1">
                                    <label for="otc" class="sr-only">{{
                                        t("access.code", "Toegangscode")
                                    }}</label>
                                    <input
                                        type="text"
                                        id="otc"
                                        ref="otc"
                                        v-model="form.input.code"
                                        inputmode="numeric"
                                        pattern="[0-9]*"
                                        :disabled="loading"
                                        class="block w-full border border-transparent rounded-md px-5 py-3 text-base text-gray-900 placeholder-gray-500 shadow-sm focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-600 disabled:opacity-50"
                                        :placeholder="form.placeholder"
                                    />
                                </div>
                                <div class="mt-4 sm:mt-0 sm:ml-3 mx-auto">
                                    <button
                                        v-if="!loading"
                                        type="submit"
                                        class="block w-full rounded-md border border-transparent px-5 py-3 text-base font-medium text-white shadow focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 sm:px-10"
                                        :class="{
                                            'bg-yellow-500 hover:bg-yellow-400 focus:ring-offset-yellow-600':
                                                form.state == 'yellow',
                                            'bg-green-500 hover:bg-green-400 focus:ring-offset-green-600':
                                                form.state == 'green',
                                            'bg-blue-500 hover:bg-blue-400 focus:ring-offset-blue-600':
                                                form.state == 'blue',
                                            'bg-red-500 hover:bg-red-400 focus:ring-offset-red-600':
                                                form.state == 'red',
                                            'bg-indigo-500 hover:bg-indigo-400 focus:ring-offset-indigo-600':
                                                form.state == 'indigo',
                                        }"
                                    >
                                        <span>{{ texts.button }} </span>
                                    </button>
                                    <icon-loader
                                        v-if="loading"
                                        class="text-white mt-3 inline-block transition-all duration-500 ease-in-out mx-auto"
                                    ></icon-loader>
                                </div>
                            </form>
                            <form
                                v-on:submit.prevent="validateSMS"
                                novalidate
                                v-if="form.type == 'validate-sms'"
                                class="mt-6 sm:mx-auto sm:max-w-xl sm:flex"
                            >
                                <div class="min-w-0 flex-1">
                                    <label for="otc" class="sr-only">{{
                                        t("access.sms-code", "SMS-code")
                                    }}</label>
                                    <input
                                        type="text"
                                        id="otc"
                                        ref="otc"
                                        v-model="form.input.code"
                                        inputmode="numeric"
                                        pattern="[0-9]*"
                                        autocomplete="one-time-code"
                                        :disabled="loading"
                                        class="block w-full border border-transparent rounded-md px-5 py-3 text-base text-gray-900 placeholder-gray-500 shadow-sm focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-600 disabled:opacity-50"
                                        :placeholder="form.placeholder"
                                    />
                                </div>
                                <div class="mt-4 sm:mt-0 sm:ml-3 mx-auto">
                                    <button
                                        v-if="!loading"
                                        type="submit"
                                        class="block w-full rounded-md border border-transparent px-5 py-3 text-base font-medium text-white shadow focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 sm:px-10"
                                        :class="{
                                            'bg-yellow-500 hover:bg-yellow-400 focus:ring-offset-yellow-600':
                                                form.state == 'yellow',
                                            'bg-green-500 hover:bg-green-400 focus:ring-offset-green-600':
                                                form.state == 'green',
                                            'bg-blue-500 hover:bg-blue-400 focus:ring-offset-blue-600':
                                                form.state == 'blue',
                                            'bg-red-500 hover:bg-red-400 focus:ring-offset-red-600':
                                                form.state == 'red',
                                            'bg-indigo-500 hover:bg-indigo-400 focus:ring-offset-indigo-600':
                                                form.state == 'indigo',
                                        }"
                                    >
                                        <span>{{ texts.button }} </span>
                                    </button>
                                    <icon-loader
                                        v-if="loading"
                                        class="text-white mt-3 inline-block transition-all duration-500 ease-in-out mx-auto"
                                    ></icon-loader>
                                </div>
                            </form>
                            <div
                                v-if="form.type == 'validate-sms' && showResend"
                                class="mt-4 sm:mx-auto sm:max-w-xl text-center"
                            >
                                <button
                                    @click="resendSMS"
                                    type="button"
                                    class="text-sm text-white underline hover:text-gray-200 transition-opacity duration-500"
                                >
                                    {{
                                        t(
                                            "access.2fa.resend",
                                            "Geen SMS ontvangen? Klik hier om opnieuw te versturen",
                                        )
                                    }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <footer class="my-4 flex justify-center">
                        <a
                            class="max-w-xl mx-auto text-sm my-6 leading-5 text-gray-500"
                            title="Log off"
                            href="/logoff"
                            ><svg
                                class="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                ></path></svg
                        ></a>
                    </footer>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SupportIcon, XIcon } from "@heroicons/vue/outline";

export default {
    components: {
        SupportIcon,
        XIcon,
    },
    mounted() {
        this.startAutoSmsTimer();
    },
    beforeUnmount() {
        clearTimeout(this.autoSmsTimer);
        clearTimeout(this.resendTimer);
    },
    data() {
        // content: "bij ons is het volgende telefoonnummer bekend:""

        return {
            autoSmsTimer: null,
            resendTimer: null,
            showResend: false,
            showButton: false,
            texts: {
                title: "Tweestapsverificatie",
                content:
                    "Een moment, je ontvangt zo een SMS met de toegangscode op:",
                topbar: "Hulp nodig? Bekijk hier de instructie-video's.",
                button: "Klik hier om een SMS te ontvangen met een toegangscode",
            },
            user: {
                email: null,
                name: null,
                phone: null,
                has_pin: false,
                hide_2fa: false,
            },
            form: {
                type: "request-sms",
                state: "blue",
                errors: null,
                success: false,
                placeholder: "",
                input: {
                    token: null,
                    code: null,
                },
            },
            loading: false,
            lang: "nl",
        };
    },
    created() {
        this.texts = {
            title: this.t("access.2fa.title", "Tweestapsverificatie"),
            content: this.t(
                "access.2fa.content",
                "bij ons is het volgende telefoonnummer bekend:",
            ),
            topbar: this.t(
                "access.2fa.topbar",
                "Hulp nodig? Bekijk hier de instructie-video's.",
            ),
            button: this.t(
                "access.2fa.button",
                "Een moment, je ontvangt zo een SMS met de toegangscode.",
            ),
        };
        this.form.placeholder = this.t(
            "access.2fa.placeholder-sms-code",
            "Code uit de SMS",
        );

        if (localStorage.getItem("redirect-to-live") === "yes") {
            this.texts.button = "SMS wordt verstuurd...";
        }

        this.user = {
            email: document.head.querySelector('meta[name="email"]').content,
            name: document.head.querySelector('meta[name="name"]').content,
            phone: document.head.querySelector('meta[name="phone"]').content,
            hide_2fa:
                document.head.querySelector('meta[name="hide_2fa"]').content ==
                "true"
                    ? true
                    : false,
            has_pin:
                document.head.querySelector('meta[name="has_pin"]').content ==
                "true"
                    ? true
                    : false,
        };

        if (this.user.phone == "error") {
            this.form.state = "red";
            this.form.type = false;
            this.texts = {
                title: this.t(
                    "access.2fa.error.title",
                    "Tweestapsverificatie niet mogelijk",
                ),
                content: this.t(
                    "access.2fa.error.content",
                    "Het telefoonnummer dat van u bekend is, is onjuist. Neem contact op met de organisatie om dit te verhelpen.",
                ),
            };
        }

        if (this.user.hide_2fa || this.user.has_pin) {
            this.texts = {
                title: this.t("access.2fa.off.title", "Toegangscode"),
                button: this.t("access.2fa.off.verify", "Verifiëren"),
                content: this.t(
                    "access.2fa.off.content",
                    "u hebt een uniek toegangsnummer gekregen van de organisator, u kunt dat hieronder invullen als alternatief voor de SMS validatie",
                ),
            };
            this.user.phone = null;
            this.form = {
                type: "validate-code",
                state: "indigo",
                errors: null,
                success: false,
                placeholder: this.t(
                    "access.2fa.off.placeholder-code",
                    "Verkregen toegangscode",
                ),
                input: {
                    code: null,
                },
            };
            this.form.placeholder = this.t(
                "access.2fa.off.placeholder-code",
                "Verkregen toegangscode",
            );
        }

        this.lang = document.documentElement.lang.substr(0, 2);
    },
    methods: {
        startAutoSmsTimer() {
            if (
                this.form.type === "request-sms" &&
                this.user.phone !== "error" &&
                !this.user.hide_2fa &&
                !this.user.has_pin
            ) {
                this.autoSmsTimer = setTimeout(() => {
                    this.showButton = true;
                    if (this.form.type === "request-sms" && !this.loading) {
                        this.requestSMS();
                    }
                }, 1000);
            } else {
                this.showButton = true;
            }
        },
        startResendTimer() {
            this.showResend = false;
            this.resendTimer = setTimeout(() => {
                this.showResend = true;
            }, 30000);
        },
        resendSMS() {
            this.showResend = false;
            this.form.type = "request-sms";
            this.requestSMS();
        },
        requestSMS() {
            let self = this;
            this.loading = true;
            axios
                .post("/get-token")
                .then((response) => {
                    this.form.state = "yellow";
                    this.form.type = "validate-sms";
                    this.texts.content = self.t(
                        "access.sms-request.content",
                        "voer de verificatiecode in die u per SMS hebt ontvangen op uw telefoon met nummer",
                    );
                    this.texts.title = self.t(
                        "access.sms-request.title",
                        "Tweestapsverificatie SMS-controle",
                    );
                    this.texts.button = self.t(
                        "access.sms-request.verify-button",
                        "Verifiëren",
                    );
                    this.loading = false;
                    setTimeout(function () {
                        document.getElementById("otc").focus();
                    }, 1000);
                    this.form.input.token = response.data.token;
                    this.startResendTimer();
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push("/login");
                    }
                    if (error.response.status == 409) {
                        // alert(error.response.data);
                    }
                    alert("Daar ging wat mis");
                });
        },
        validateSMS() {
            let self = this;
            this.loading = true;
            axios
                .post("/validate-token", {
                    token: this.form.input.token,
                    pincode: this.form.input.code,
                })
                .then((response) => {
                    this.form.state = "green";
                    this.user = {};
                    this.texts = {
                        title: "✅",
                        content: "",
                        topbar: "",
                    };
                    this.form.type = "success";
                    this.$router.push("/dashboard");
                })
                .catch((error) => {
                    this.user = {};
                    self.form.state = "red";
                    if (error.response.status == 404) {
                        this.$router.push("/login");
                    } else if (error.response.status == 422) {
                        var errors = error.response.data.errors;
                        this.texts.content = errors["pincode"].toString();
                    } else if (error.response.status == 409) {
                        this.texts.content = error.response.data.error;
                    } else {
                        alert("Daar ging wat mis");
                    }
                    setTimeout(function () {
                        if (self.form.state == "red") {
                            self.form.state = "blue";
                        }
                    }, 3000);
                    this.loading = false;
                });
        },
        validateCode() {
            let self = this;
            this.loading = true;
            axios
                .post("/validate-pincode", {
                    pincode: this.form.input.code,
                })
                .then((response) => {
                    this.form.state = "green";
                    this.texts = {
                        title: "✅",
                        content: "",
                        topbar: "",
                    };
                    this.form.type = "success";
                    this.$router.push("/dashboard");
                })
                .catch((error) => {
                    self.form.state = "red";
                    this.user.name = null;
                    if (error.response.status == 404) {
                        this.$router.push("/login");
                    } else if (error.response.status == 422) {
                        var errors = error.response.data.errors;
                        this.texts.content = errors["pincode"].toString();
                    } else if (error.response.status == 409) {
                        this.texts.content = error.response.data.error;
                    } else {
                        alert("Daar ging wat mis");
                    }
                    setTimeout(function () {
                        if (self.form.state == "red") {
                            self.form.state = "blue";
                        }
                    }, 3000);
                    this.loading = false;
                });
        },
    },
};
</script>
